export default {
  DEVELOPER: 'Developer',
  CEO: 'CEO',
  MARKETER: 'Marketer',
  MARKETER_VALUE: 'Marketing',
  OTHER: 'Other',
  LV_EMAIL: '0 to 100,000',
  MLV_EMAIL: '100,000 to 700,000',
  MV_EMAIL: '700,000 to 1,500,000',
  MHV_EMAIL: '1,500,000 to 10,000,000',
  HLV_EMAIL: '10,000,000 to 50,000,000',
  HMV_EMAIL: '50,000,000 to 100,000,000',
  HV_EMAIL: '100,000,000+',
  LV_EMAIL_VAL: '0 to 100k',
  MLV_EMAIL_VAL: '100k to 700k',
  MV_EMAIL_VAL: '700k to 1.5M',
  MHV_EMAIL_VAL: '1.5M to 10M',
  HLV_EMAIL_VAL: '10M to 50M',
  HMV_EMAIL_VAL: '50M to 100M',
  HV_EMAIL_VAL: '100M+',
  LV_EMPLOYEE: '1 - 500',
  MHV_EMPLOYEE: '1,001 - 5,000',
  MLV_EMPLOYEE: '501 - 1,000',
  HV_EMPLOYEE: '5,001+',
};
